module.exports = __webpack_public_path__ + "img/filter.31a862a4.svg";